import { Flex, SkeletonBox, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

// Heights of the blocks in DocumentTypeSettingsFormFields, measured at full width.
// The item columns block is 20px heading + 8px gap + a bordered box: 1px border, 16px padding, two 22px
// switch rows with an 8px gap, 16px padding, 1px border. The totals block is a 74px form item with a select.
// VAT-exempt organizations have no totals field, so that block is left out.
// A text block is 20px label + 4px gap + 74px two-line textarea + 4px gap + 16px counter.
// The T&C block is 20px heading + 8px gap + a 162px bordered box with the switch row and the textarea.
const itemColumnsSkeleton = { height: 114, id: 'item-columns' }
const totalsSkeleton = { height: 74, id: 'totals' }

const textSkeletons = [
  { height: 118, id: 'message' },
  { height: 118, id: 'footer-note' },
  { height: 190, id: 'terms-and-conditions' },
]

export const DocumentTypeSettingsFormFieldsSkeletons = (): ReactElement => {
  const { organization } = useUserOrganization()

  const columnSkeletons = organization?.isVatExempted ? [itemColumnsSkeleton] : [itemColumnsSkeleton, totalsSkeleton]

  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      {columnSkeletons.map(({ height, id }) => (
        <SkeletonBox fullWidth height={height} key={id} />
      ))}
      <Flex flexDirection="column" gap={Spacing.S16}>
        {textSkeletons.map(({ height, id }) => (
          <SkeletonBox fullWidth height={height} key={id} />
        ))}
      </Flex>
    </Flex>
  )
}
